import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
    selector: '[appCmsBlock]',
    standalone: false,
})
export class CmsBlockDirective {
    constructor(public viewContainerRef: ViewContainerRef) {}
}
